import { Button, styled } from '@cherre-frontend/ui';

export const ConnectorStageBannerContainer = styled('div')`
  border-radius: 10px;
  padding: 10px;
  background-color: #fffbed;
  color: #ad5d00;
  font-size: 14px;
  letter-spacing: 1%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
`;

export const MessageIconContainer = styled('div')`
  gap: 12px;
  display: flex;
  align-items: center;
`;

export const StatusContent = styled('span')`
  font-weight: 500;
`;

export const MessageContainer = styled('p')`
  margin: 0;
`;

export const MessageContent = styled('span')``;

export const StyledButton = styled(Button)`
  padding: 0;
  min-width: unset;
  line-height: 0;
`;
